/**
 * Management → Closing Cost Setting。
 * 打开页面打 STATSIG.COMMON.VIEW，value=mgmt_closing_cost_setting。
 *
 * 正在用：
 * - 顶栏 / 分区 Use Lodestar 开关落库
 * - Save changes 保存手填费用
 * 都打 UPDATE。
 *
 * 已不算：Add more / 删行、Learn how Lodestar works、折叠、跳 Lenders。
 */
export enum MgmtClosingCostSettingEvent {
    /** Use Lodestar 开关落库，或点 Save changes */
    UPDATE = 'CLOSING_COST_SETTING_UPDATE',
}
